import React, {useState} from 'react';
import styled, {createGlobalStyle} from 'styled-components';
import Header from './components/Header/Header.jsx';
import StatsChart from './components/StatsChart/StatsChart.jsx';
import VkConnectCard from './components/VkConnectCard/VkConnectCard.jsx';
import TariffCard, {Tariffs} from './components/TariffCard/TariffCard.jsx';
import SupportCard from './components/SupportCard/SupportCard.jsx';
import ContactsModal from './components/ContactsModal/ContactsModal.jsx';
import PaymentModal from './components/PaymentModal/PaymentModal.jsx';
import BottomNav from './components/BottomNav/BottomNav.jsx';
import VkPosts from "./components/Posts/VkPosts";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background-color: #f4f5f7;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
  }
`;

const AppContainer = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #f8f9fa;
  position: relative;
  padding-bottom: 70px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
`;

export default function App() {
    const [activeTab, setActiveTab] = useState('dashboard');
    const [paymentOpen, setPaymentOpen] = useState(false);
    const [price, setPrice] = useState(false);

    const onConnect = () => {
        setActiveTab('vk')
    }

    return (
        <>
            <GlobalStyle/>
            <AppContainer>
                <Header/>
                {activeTab === 'dashboard' && (<>
                    <VkConnectCard isLite={true} onConnect={onConnect}/>
                    <StatsChart onConnect={onConnect}/>
                    <VkPosts isLite={true} onConnect={onConnect}/>
                    <TariffCard onOpenPayment={(price) => {setPrice(price);setPaymentOpen(true)}}/>
                </>)}
                {activeTab === 'vk' && (<div style={{padding: '16px 0'}}>
                    <VkConnectCard/>
                </div>)}
                {activeTab === 'posts' && (<div style={{padding: '16px 0'}}>
                    <VkPosts/>
                </div>)}

                {activeTab === 'tariff' && (<div style={{padding: '16px 0'}}>
                    <Tariffs onOpenPayment={(price) => {setPrice(price);setPaymentOpen(true)}}/>
                </div>)}
                {activeTab === 'support' && (<div style={{padding: '16px 0'}}>
                    <SupportCard/>
                    <ContactsModal/>
                </div>)}
                <BottomNav activeTab={activeTab} onChangeTab={setActiveTab}/>
                <PaymentModal price={price} open={paymentOpen} onClose={() => setPaymentOpen(false)}/>
            </AppContainer>
        </>
    );
}
